<template>

  <div class="bg-[#798B97] w-full h-[calc(100vh-189px)] rounded-t-[20px] pt-[11px] flex justify-center items-center sm:min-w-[423px]" id="orderComplete">
    <div class="flex justify-center items-center flex-col">
      <svg xmlns="http://www.w3.org/2000/svg" width="133.247" height="133.852" viewBox="0 0 133.247 133.852">
        <g id="svgexport-6_29_" data-name="svgexport-6 (29)" transform="translate(0 0)">
          <g id="Checkmark">
            <path id="Subtraction_1" data-name="Subtraction 1" d="M-351.1-2883.328a65.952,65.952,0,0,1-25.933-5.259,66.388,66.388,0,0,1-21.177-14.343,66.722,66.722,0,0,1-14.278-21.273,66.771,66.771,0,0,1-5.236-26.051,66.771,66.771,0,0,1,5.236-26.051,66.726,66.726,0,0,1,14.278-21.273,66.389,66.389,0,0,1,21.177-14.343,65.951,65.951,0,0,1,25.933-5.259,66.039,66.039,0,0,1,25.917,5.283,66.471,66.471,0,0,1,21.166,14.345,66.814,66.814,0,0,1,14.28,21.263,66.863,66.863,0,0,1,5.259,26.035,66.769,66.769,0,0,1-5.236,26.051,66.721,66.721,0,0,1-14.278,21.273,66.39,66.39,0,0,1-21.177,14.343A65.95,65.95,0,0,1-351.1-2883.328Zm-27.76-72.487a5.487,5.487,0,0,0-3.914,1.629,5.587,5.587,0,0,0,0,7.864l19.432,19.521a5.52,5.52,0,0,0,3.914,1.645,5.518,5.518,0,0,0,3.914-1.645l40.847-41.033.651-.651c.039-.039.076-.078.114-.117l.029-.029a5.587,5.587,0,0,0,0-7.864,5.486,5.486,0,0,0-3.914-1.629,5.484,5.484,0,0,0-3.914,1.629l-24.352,24.444-13.309,13.3-15.447-15.42a5.477,5.477,0,0,0-2.939-1.53A5.524,5.524,0,0,0-378.859-2955.815Z" transform="translate(417.723 3017.181)" fill="#fff"/>
          </g>
        </g>
      </svg>
      <div class="mt-3 text-center text-[50px] font-bold text-white"> 64 {{lang === 'en' ? 'SR' : 'ريال'}} </div>
      <div class="w-full max-w-[300px] text-[20px] text-center text-white">
        {{lang === 'en' ? 'Your payment is complete. Please check the Pickup status at Order Status Page' : 'تم إتمام عملية الدفع الخاصة بك. يُرجى التحقق من حالة الاستلام في صفحة حالة الطلب'}}
      </div>
    </div>
  </div>
  <div class="h-[99px] w-full bg-[#E0E9F0] rounded-b-[21px] px-[21px] py-[16px] pb-[19px]">
    <button type="button" class="text-[18px] sm:text-[21px] font-bold text-white bg-[#C6A798] flex justify-center items-center rounded-[12px] w-full h-[64px] hover:bg-[#B28F85] duration-500" id="order-complete" @click="handleOrderComplete($event)">
      {{lang === 'en' ? 'Continue' : 'يكمل'}}
    </button>
  </div>

</template>

<script>

export default {
  data(){
    return {
      lang: window?.core?.lang,
    }
  },
  mounted() {

  },
  methods: {
    handleOrderComplete(e){
      e.stopPropagation();
      this.$emit('handleOrderComplete', false)
    },
  }
}

</script>